import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=4db6fa13&scoped=true"
import script from "./Key.vue?vue&type=script&lang=js"
export * from "./Key.vue?vue&type=script&lang=js"
import style0 from "./Key.vue?vue&type=style&index=0&id=4db6fa13&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6fa13",
  null
  
)

export default component.exports